export const SHIPPING_STEP = 'shipping';
export const PAYMENT_STEP = 'payment';
export const CONFIRMATION_STEP = 'confirmation';

export type CheckoutStep = 'shipping' | 'payment' | 'confirmation';

export function isShippingStep(step: CheckoutStep) {
  return step === SHIPPING_STEP;
}
